
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { House } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ResidentialHeroSectionProps {
  onOpenPopup: () => void;
}

const ResidentialHeroSection = ({ onOpenPopup }: ResidentialHeroSectionProps) => {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-16 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden section-float">
      {/* Tech Background Animations */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-10">
        <div className="absolute top-20 left-10 w-32 h-32 bg-nexx-green/5 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-24 h-24 bg-blue-500/5 rounded-lg rotate-45 animate-bounce" style={{ animationDuration: '3s' }}></div>
        <div className="absolute bottom-40 left-20 w-20 h-20 bg-green-500/5 rounded-full animate-ping" style={{ animationDelay: '1s', animationDuration: '4s' }}></div>
        <div className="absolute bottom-20 right-40 w-16 h-16 bg-nexx-green/5 rounded-lg animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-20">
        <div className="text-center max-w-4xl mx-auto">
          <div className="relative inline-block mb-6">
            <House 
              className="w-12 h-12 text-nexx-green mx-auto mb-2 animate-pulse"
              style={{
                filter: 'drop-shadow(0 0 10px rgba(34, 197, 94, 0.6)) drop-shadow(0 0 20px rgba(34, 197, 94, 0.3))'
              }}
            />
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight animate-fade-in">
              <span 
                className="text-nexx-green"
                style={{
                  filter: 'drop-shadow(0 0 10px rgba(34, 197, 94, 0.6)) drop-shadow(0 0 20px rgba(34, 197, 94, 0.3))'
                }}
              >
                Clean Residential
              </span>
              <span className="text-gray-900"> Proxies.</span>
              <span className="relative inline-block ml-2">
                <span 
                  className="relative z-10 text-gray-900"
                  style={{
                    background: 'linear-gradient(90deg, rgba(34, 197, 94, 0.3) 0%, rgba(34, 197, 94, 0.3) 100%)',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'left center',
                    backgroundSize: '0% 100%',
                    animation: 'highlighter 2s ease-out 1s forwards'
                  }}
                >
                  Ethically Sourced.
                </span>
              </span>
              <span className="block text-gray-900">Fully Yours.</span>
            </h1>
          </div>
          <p className="text-xl text-gray-600 leading-relaxed mb-8 animate-fade-in" style={{ animationDelay: '200ms' }}>
            No recycled IPs. No shady pools. Just pure residential access backed by real provider contracts.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" style={{ animationDelay: '400ms' }}>
            <Button 
              size="lg" 
              className="bg-nexx-green hover:bg-green-700 text-white px-8 py-4 text-lg group"
              onClick={scrollToPricing}
            >
              View Pricing
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-nexx-green text-nexx-green hover:bg-nexx-green hover:text-white px-8 py-4 text-lg"
              onClick={onOpenPopup}
            >
              Start Free Trial
            </Button>
            <Link to="/proxy-tos">
              <Button 
                size="lg" 
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 text-lg"
              >
                Read Our TOS
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResidentialHeroSection;
